import React from 'react'
import styled from 'styled-components'
import { StaticImage } from 'gatsby-plugin-image'
import { Text, Title } from '@mantine/core'
import { Media } from '@raysync/common/theme'
import { useMedia } from '@raysync/common/hooks'
import {
  YouTubeEmbed,
  Layout,
  LargeWrapper,
  Link,
  ShowAtMobile,
  HideAtMobile,
  MantineWrapper,
} from '@raysync/common/components'

const BgContainer = styled.div`
  position: relative;
  padding: 160px 0 100px;
  height: 90vh;
  display: flex;
  align-items: center;
  ${Media.phone`
    height: unset;
    padding: 0.8rem 0 .6rem;
  `}
`

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const Header = styled(Title)`
  font-size: 46px;
  margin-bottom: 20px !important;
  line-height: 1.2;
  color: #333;
  span {
    color: ${p => p.theme.color.secondary};
  }
  ${Media.phone`
    font-size: .64rem;
    margin-bottom: .16rem;
  `}
`

const SubHeader = styled(Text)`
  font-size: 16px;
  color: #666;
  max-width: 675px;
  text-align: center;
  margin-bottom: 48px !important;
  line-height: 1.6 !important;
  a {
    font-size: 16px;
    padding: 0 6px;
    color: ${p => p.theme.color.secondary};
  }
  ${Media.phone`
    font-size: .24rem;
    margin-bottom: .16rem;
    max-width: unset;
    margin-bottom: .8rem;
    a {
      font-size: .24rem;
    }
  `}
`

const VideoContainer = styled.div`
  display: flex;
  justify-content: center;
  ${Media.phone`
    flex-wrap: wrap;
  `}
`

const VideoCard = styled.div`
  > div {
    height: 290px;
    width: 505px;
    padding: 10px;
    transition: all 0.3s linear;
    border-radius: 10px;
    iframe {
      border-radius: 10px;
    }
    :hover {
      background-color: #fff;
      box-shadow: 0px 10.78px 37.04px 0px rgba(34, 60, 123, 0.16);
    }
  }
  & + & {
    margin-left: 70px;
  }
  ${Media.phone`
    width: 100%;
    > div {
      height: 3.6rem;
      width: 100%;
    }
    & + & {
     margin-left: unset;
    }
    margin-bottom: .6rem;
  `}
`

const VideoDescription = styled.p`
  font-size: 18px;
  color: #333;
  margin-top: 28px;
  ${Media.phone`
    font-size: .24rem;
    margin-top: .24rem;
  `}
`

function ApplySuccess({ location }) {
  const isMobile = useMedia()
  return (
    <Layout pageType='apply' filled={!isMobile} location={location}>
      <MantineWrapper>
        <BgContainer>
          <LargeWrapper>
            <AppContainer>
              <Header order={1}>
                We appreciate your interest in a <span>free trial!</span>
              </Header>
              <SubHeader>
                Our sales team will reach out to you shortly to discuss your specific needs. In the meantime, feel free
                to watch the video or visit our
                <Link to='/support/document/index/' isInternal={false}>
                  Help Center
                </Link>
                for additional information.
              </SubHeader>
              <VideoContainer>
                <VideoCard>
                  <YouTubeEmbed videoId='k1H_vGb-WCs' />
                  <VideoDescription>Discover more about Raysync</VideoDescription>
                </VideoCard>
                <VideoCard>
                  <YouTubeEmbed videoId='_jpBr8lTSCE' />
                  <VideoDescription>Discover more about Raysync Cloud</VideoDescription>
                </VideoCard>
              </VideoContainer>
            </AppContainer>
          </LargeWrapper>
          <HideAtMobile>
            <StaticImage
              formats={['png']}
              src='../../images/success_bg.png'
              alt='background'
              layout='constrained'
              className='billboard'
            />
          </HideAtMobile>
          <ShowAtMobile>
            <StaticImage
              formats={['png']}
              src='../../images/success_bg_m.png'
              alt='background'
              layout='constrained'
              className='billboard'
            />
          </ShowAtMobile>
        </BgContainer>
      </MantineWrapper>
    </Layout>
  )
}

export default ApplySuccess
